import { useState } from 'react'
import { Flex, Box, Text, Button, Image, AspectRatio, Badge, 
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton } from '@chakra-ui/react';
import { SyncLoader } from 'react-spinners';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { LazyLoadImage } from 'react-lazy-load-image-component';



import { useTranslation } from 'react-i18next';

import './Styles/Menu.css';
import FeedInAppLogo from './../../assets/logo.png'

const MenuItemModal = (props) => {

    const { t } = useTranslation(); 
    const { closeAction, isDialogOpen, name, description, price, image, isVegetarian, isFrozen, isVegan, isGlutenFree, allergens, designation, gastronomicMatches, technicalities } = props;

    return (
        <Modal isCentered onClose={closeAction} isOpen={isDialogOpen} motionPreset="slideInBottom"  >
                <ModalOverlay />
                <ModalContent>
                
                <ModalHeader>{name}</ModalHeader>
                <ModalCloseButton />

                <ModalBody maxHeight="65vh" overflow="auto">
                    { image && 
                        <AspectRatio width="100%" ratio={16.0/9.0}>
                            <Box width="100%" height="100%" position="relative">
                                {
                                    /*
                                        <Flex width="100%" height="100%" justifyContent="center" alignItems="center" direction="column" position="absolute">  
                                            <Image src={FeedInAppLogo} width="20%" maxWidth="150px" mb={4}/>
                                            <SyncLoader size={15} color="#4BAC61" loading={true} margin={2} style={{position: 'absolute', left: '50%', top:'50%'}}/>
                                            <Text pl={3} pr={2} fontSize="sm" fontWeight="normal" color="lightblack" mt={2}> 
                                                {t("menu_modal_loading_text")}
                                            </Text>
                                        </Flex>
                                    */
                                }

                                
                                { /*<Image
                                    objectFit="cover"
                                    src={image}
                                    alt={description}
                                    width="100%"
                                    height="100%"
                                    position="absolute"
                                />*/
                                }

                            <TransformWrapper>
                                <TransformComponent>
                                    <LazyLoadImage
                                        position="absolute"
                                        alt={description}
                                        height="100%"
                                        src={image} // use normal <img> attributes as props
                                        width="100%" 
                                        style={{
                                            zIndex: 1
                                        }}
                                    />
                                </TransformComponent>
                            </TransformWrapper>

                            </Box> 
                        </AspectRatio>
                    }

                    { (isVegetarian || isFrozen || isGlutenFree !== null || isVegan) && 
                        <Flex mt={ image ? 2:0 }>
                            { isVegetarian && <Badge colorScheme="green" mr={2}>{ t("vegetarianBadge") }</Badge> }
                            { isVegan && <Badge colorScheme="whatsapp" mr={2}>{ t("veganBadge") }</Badge> }
                            { isGlutenFree === true && <Badge colorScheme="orange" mr={2}>{ t("glutenFreeBadge") }</Badge> }
                            { isGlutenFree === false && <Badge colorScheme="orange" mr={2}>{ t("notGlutenFreeBadge") }</Badge> }
                            { isFrozen && <Badge colorScheme="cyan" ml={isVegetarian ? 2:0} mr={2}>{ t("frozenBadge") }</Badge> }
                        </Flex>
                    }

                    <Text width="100%" fontWeight="normal" fontSize="medium" mt="2" className="capitalize" > 
                        {description}
                    </Text>

                    { !!designation &&
                        <>
                            <Text fontWeight="semibold" fontSize="regular" mt={4}>
                                { t("modal_wine_designations") }
                            </Text>                         
                            <Flex mt={2}>
                                {
                                    designation.map( designation => (
                                        <Badge colorScheme="messenger">
                                            { designation }
                                        </Badge>
                                    ))
                                }
                            </Flex>
                        </>
                    }

                    { (allergens.length > 0) &&
                        <Flex mt="2" mr="2" alignItems="center" flexWrap="wrap">
                            <Text colorScheme="red" fontWeight="semibold">
                                { t("allergens") }
                            </Text>
                            { allergens.map((allergen, index) => <Badge colorScheme="red" ml={2} key={index}> { allergen } </Badge> ) } 
                        </Flex>
                    }

                    { !!gastronomicMatches && 
                        <>
                            <Text fontWeight="semibold" fontSize="regular" mt={4}>
                                { t("modal_wine_gastronomic_matches") }
                            </Text>                         

                            <Text fontWeight="medium" fontSize="sm" mt={1}>
                                { gastronomicMatches }
                            </Text> 
                        </>
                    }

                    { !!technicalities && 
                        <>
                            <Text fontWeight="semibold" fontSize="regular" mt={4}>
                                { t("modal_wine_technicalities") }
                            </Text>                         

                            <Text fontWeight="medium" fontSize="sm" mt={1}>
                                { technicalities }
                            </Text> 
                        </>
                    }

                    { price && 
                    <Text fontWeight="semibold" fontSize="medium" mt="4" whiteSpace="noWrap">
                        { t("priceModal") + ' ' + price + ' €'}
                    </Text> }
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme="green" mr={3} onClick={closeAction} bg="primary">
                        { t("closeModal") }
                    </Button>
                </ModalFooter>

                </ModalContent>
            </Modal>
            
            
    );
    
}

export default MenuItemModal;